import { render, staticRenderFns } from "./myCouresList.vue?vue&type=template&id=0d469ce3&scoped=true"
import script from "./myCouresList.vue?vue&type=script&lang=js"
export * from "./myCouresList.vue?vue&type=script&lang=js"
import style0 from "./myCouresList.vue?vue&type=style&index=0&id=0d469ce3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d469ce3",
  null
  
)

export default component.exports